import React, { FC } from 'react';
import classNames from 'classnames';
import css from './MobileDishGiftIngredient.module.scss';

import GiftIcon from './img/gift.component.svg';

interface IProps {
    text: string,
    oldPrice: number
    color: 'green' | 'blue'
}

export const MobileDishGiftIngredient: FC<IProps> = ({ text, oldPrice, color = 'green' }: IProps) => {
    const oldPriceClasses = classNames({
        [css.giftIngredientTitle]: true,
        [css.small]: true,
        [css.crossed]: true,
        [css.light]: true,
    });
    const currentPriceClasses = classNames({
        [css.giftIngredientTitle]: true,
        [css.compressed]: true,
    });
    const giftIngredientRoot = classNames({
        [css.giftIngredientRoot]: true,
        [css[color]]: true,
    });

    return (
        <div className={giftIngredientRoot}>
            <div className={css.giftIngredientLeftSide}>
                <div className={css.giftIcon}>
                    <GiftIcon />
                </div>
                <div className={css.giftIngredientTitle}>{text}</div>
            </div>
            <div className={css.giftIngredientPricesContainer}>
                <div className={currentPriceClasses}>0 ₽</div>
                <div className={oldPriceClasses}>{`${oldPrice}₽`}</div>
            </div>
        </div>
    );
};
